import * as React from "react";
const SvgAscend = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, id: "arrow", ...props }, /* @__PURE__ */ React.createElement("g", { color: "#000" }, /* @__PURE__ */ React.createElement("path", { fill: "#cad1d8", style: {
  isolation: "auto",
  mixBlendMode: "normal"
}, d: "m-565 1374.362-10 13h5v15h10v-15h5l-10-13z", overflow: "visible", transform: "translate(581 -1372.362)" }), /* @__PURE__ */ React.createElement("path", { fill: "#f05542", d: "m-571.25 1382.487-1.25 1.625-2.5 3.25h5v15h10v-15h5l-2.5-3.25-1.25-1.625z", overflow: "visible", style: {
  isolation: "auto",
  mixBlendMode: "normal"
}, transform: "translate(581 -1372.362)" })));
export default SvgAscend;
